export default __webpack_public_path__ + "img/foyer-homepage.ec7d4653.svg";